// src/components/InfoModals/ScoringModal.js
import { useConfig } from "../../contexts/ConfigContext";
import { CloseIcon } from "../../assets/icons/icons";
import "./style.css";

export default function ScoringModal({ isOpen, closeModal }) {
  const { config } = useConfig();
  const { gradeScale } = config;

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div
        className="modal-content scoring-modal"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>SWP Grading Scale</h2>
          <CloseIcon onClick={closeModal} className="cancel-icon" />
        </div>
        <div className="scoring-table">
          <div className="scoring-table-header">
            <span>Color</span>
            <span>Grade</span>
            <span>Range</span>
            <span>Description</span>
          </div>
          {Object.entries(gradeScale).map(([grade, { color, description, min, max }]) => (
            <div key={grade} className="scoring-table-row">
              <span>
                <div
                  className="grade-circle"
                  style={{ backgroundColor: color, display: "inline-block" }}
                />
              </span>
              <span>Grade {grade}</span>
              <span>{min !== -1 ? `${min}–${max}` : "N/A"}</span>
              <span className="grade-desc">{description}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
